import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	betaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betaLabel: {
		id: 'servicedesk-insight-landing-page.data-manager-link.beta-label',
		defaultMessage: 'BETA',
		description: 'Label shown in lozenge to indicate beta status',
	},
});
export default messages;
